import React, { useState, useEffect, useCallback, useRef } from "react";

import Typography from "@mui/material/Typography";
import { getDashboards } from "../Service/dashboards";

import { CircularProgress } from "@mui/material";
import CandleChart from "./CandleChart";
import TimeControl from "./TimeControl";
import IndicatorSelector from "./IndicatorSelector";

import { useTheme } from "@mui/material/styles";

const PER_SCROLL = 10;

const Dashboard = (props) => {
  const [data, setData] = useState();
  const [noData, setNoData] = useState(true);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [currentOffset, setCurrentOffset] = useState(0);
  const loaderRef = useRef(null);

  const theme = useTheme();

  const handleOnSymbolRemove = (params) => {
    console.log("PENDING");
  };

  useEffect(() => {
    try {
      getDashboards(currentOffset, PER_SCROLL).then((response) => {
        setData(response.data);
        setHasMore(response.total > currentOffset + PER_SCROLL);
        // setDashboard(data[0]);
        setLoading(false);
        console.log("here2");
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }, []);

  const fetchMore = useCallback(async () => {
    setLoading(true);
    console.log(`currentOFfset: ${currentOffset}`);
    if (hasMore) {
      getDashboards(currentOffset + PER_SCROLL, PER_SCROLL).then((response) => {
        setData([...data, ...response.data]);
        // // setTotal(response.total);
        setHasMore(response.total > currentOffset + PER_SCROLL);
        setCurrentOffset(currentOffset + PER_SCROLL);
      });
    }
  }, [currentOffset, loading, hasMore]);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const target = entries[0];
      if (target.isIntersecting) {
        fetchMore();
      }
    });

    if (loaderRef.current) {
      observer.observe(loaderRef.current);
    }

    return () => {
      if (loaderRef.current) {
        observer.unobserve(loaderRef.current);
      }
    };
  }, [fetchMore]);

  useEffect(() => {
    if (data !== undefined && data !== null) {
      setLoading(false);
      setNoData(false);
    }
  }, [data]);

  return (
    <div style={{ marginLeft: "10px" }}>
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            marginTop: "20px",
            justifyContent: "space-evenly",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h4"
            color={theme.palette.primary.main}
            style={{ flexGrow: 1 }}
          >
            {props.name}
          </Typography>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <IndicatorSelector />
          <TimeControl />
        </div>
        {/* {loading && <CircularProgress />} */}
        {noData ? (
          <Typography>No data was received</Typography>
        ) : (
          <div
            style={{
              marginTop: "10px",
              marginRight: "10px",
              marginBottom: "30px",
              display: "flex",
              flexDirection: "row",
              maxWidth: "100vw",
              flexWrap: "wrap",
            }}
          >
            {data?.map((element, index) => {
              const symbol =
                element["etf"] !== "" ? element["etf"] : element["index"];
              return (
                <CandleChart
                  key={`${index}_${symbol}`}
                  title={symbol}
                  indexStock={element["index"]}
                  width={430}
                  height={600}
                  renderOptions={true}
                  onRemove={handleOnSymbolRemove}
                ></CandleChart>
              );
            })}
          </div>
        )}
        <div id="loader" ref={loaderRef}>
          {hasMore ? <Typography color={"white"}>Loading...</Typography> : <Typography color={"white"}>You have reached the end!</Typography>}
          {loading && hasMore && <CircularProgress />}
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
